import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Sync GAINS Vendor Catalog
 *
 * Makes the supplier catalog's GAINS rows match the INITINFC mirrors: a row
 * wherever GAINS buys an item at a location from a vendor. The engine reads
 * these rows to decide which supplier sells an item at a location, for lane
 * supplier filters and "doesn't buy" lists. Rows that came from SKUSUPPARM are
 * never overwritten.
 *
 * It reads every mirror at once, so run it once after the INITINFC files
 * land, never inside the ingest's per-file fanout. The "Supply Network GAINS
 * Sync" workflow runs it daily after the INITINFC ingest.
 */
export const syncGainsVendorCatalogStep = defineStepConfig({
  type: "sync_gains_vendor_catalog",
  name: "Sync GAINS Vendor Catalog",
  description:
    "Makes the supplier catalog's GAINS rows match the INITINFC mirrors: a row wherever GAINS buys an item at a location from a vendor, which supply network lane filters and buying exceptions read. SKUSUPPARM rows are never overwritten. Run it once after the INITINFC files land.",
  category: "Transformation",
  libraryModule: "Procurement",
  inputSchema: z.object({}),
  outputSchema: z.object({
    mirrors: z.number().describe("INITINFC mirrors read"),
    vendorRows: z.number().describe("Item, location and vendor rows in GAINS"),
    added: z.number().describe("Catalog rows added"),
    updated: z.number().describe("Catalog rows updated"),
    removed: z.number().describe("GAINS catalog rows GAINS no longer lists"),
    alreadyInCatalog: z
      .number()
      .describe("Rows already in the catalog from another source"),
    unknownVendors: z
      .number()
      .describe("GAINS vendor codes with no matching supplier"),
  }),
  configSchema: z.object({}),
  emits: [] as const,
  execution: {
    startToCloseTimeout: "30 minutes",
    retry: { maximumAttempts: 2 },
  },
});
